'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableTrials = undefined;

var _trialApi = require('self-service-api/core/api/trialApi');

var _availableTrialsAdapter = require('self-service-api/adapters/availableTrialsAdapter');

var _availableTrialsAdapter2 = _interopRequireDefault(_availableTrialsAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAvailableTrials = exports.getAvailableTrials = function getAvailableTrials() {
  return _trialApi.TrialsApi.getAvailableTrials().then(function (availableTrials) {
    return (0, _availableTrialsAdapter2.default)(availableTrials);
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/api/getAvailableTrials.js
// module id = 452
// module chunks = 3 4 5